import { useDispatch } from "react-redux";
import CardFavoris from "../../components/CardFavoris";
import { addToFavorites, removeFromFavorites } from "../../store/slices/favorisSlice";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import LoadPic from "../../assets/images/blue-loading-gif-transparent.gif";
import { useState } from "react";
import { slugify } from "../../utils/utils";

const BlocEtablissement = (props) => {
  const [loadingId, setLoadingId] = useState(null);
  const [optimisticFavorites, setOptimisticFavorites] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleToggleFavorite = async (etablissement) => {
    const isCurrentlyFavorited = 
      optimisticFavorites.includes(etablissement.id) || 
      etablissement?.is_favorited;

    // Optimistic update
    setOptimisticFavorites(prev => 
      isCurrentlyFavorited 
        ? prev.filter(id => id !== etablissement.id) 
        : [...prev, etablissement.id]
    );

    setLoadingId(etablissement.id);
    
    try {
      if (isCurrentlyFavorited) {
        await dispatch(addToFavorites(etablissement.id));
        // toast.success("Removed from favorites");
      } else {
        await dispatch(addToFavorites(etablissement.id));
        // toast.success("Added to favorites");
      }
    } catch (error) {
      // console.error("Error:", error);
      toast.error("An error occurred");
      
      // Revert optimistic update on error
      setOptimisticFavorites(prev => 
        isCurrentlyFavorited 
          ? [...prev, etablissement.id] 
          : prev.filter(id => id !== etablissement.id)
      );
    } finally {
      setLoadingId(null);
    }
  };

  if (props?.status === "loading") {
    return (
      <>
        <h3 className="grey500">
          <Skeleton width={100} />
        </h3>
        <div className="row mb-5">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="col-md-3 col-xs-6 px-0">
              <div className="card-twyny">
                <Skeleton width={120} height={40} />
              </div>
            </div>
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      {props?.etablissements?.length ? (
        <>
          <h3 className="grey500 mt-40 mb-0">{props?.title}</h3>
          <div className="row mt-24">
            {props?.etablissements?.map((etablissement, index) => {
              const isFavorited = 
                optimisticFavorites.includes(etablissement.id) || 
                etablissement?.is_favorited;
              
              return (
                <div className="col-md-3" key={index}>
                  <CardFavoris
                    iconImmediat={etablissement?.immediat}
                    name={etablissement?.nom}
                    profession={etablissement?.activite?.name}
                    rating={etablissement?.average_rating}
                    reviews={etablissement?.reviews_count}
                    address={etablissement?.adresse_postale}
                    services={etablissement?.lieu_intervention}
                    photos={etablissement?.photos}
                    className="card"
                    onAddToFavorites={(e) => {
                      e.stopPropagation();
                      handleToggleFavorite(etablissement);
                    }}
                    bg={false}
                    onClick={() =>
                      // navigate(`/etablissement/${etablissement?.id}`, {
                      //   replace: true,
                      // })
                      navigate(`/etablissement/${etablissement?.slug}`,{state:{idEtablissement:etablissement?.id}})
                      
                      
                    }
                    pic={
                      loadingId === etablissement.id ? (
                        <img src={LoadPic} className="icon-button" alt="Loading" />
                      ) : isFavorited ? (
                        <img
                          src="/images/favorisHeart.svg"
                          className="icon-button"
                          alt="Favorited"
                        />
                      ) : (
                        <img
                          src="/images/heart.svg"
                          className="icon-button"
                          alt="Add to favorites"
                        />
                      )
                    }
                  />
                </div>
              );
            })}
          </div>
          <div className="mb-80"></div>
        </>
      ) : null}
    </>
  );
};

export default BlocEtablissement;